@if (!disableHeader) {
  <ion-header>
    <ion-toolbar>
      <ion-buttons slot="start">
        <ion-menu-button (click)="closePopup()"></ion-menu-button>
      </ion-buttons>
      <ion-title style="font-size: 13px;">
        <div class="titleBar adjustedTitleFont">
          {{ 'FLAVORS'  | translate }}
          <!--
          @if (NotificationService.showNotificationBell) {
            <ion-buttons class="notificationbutton" (click)="this.NotificationBellService.openNotificationBell(this.AllNotifications)">
              <div class="bellimgContainer">

                <app-app-icon [icon]="bellIcon" id="bellsize"></app-app-icon>
                @if (this.valideNotification > 0) {
                  <div class="notificationCircle">
                    <p>{{this.valideNotification}}</p>
                  </div>
                }
              </div>
            </ion-buttons>
          }
          -->
        </div>
      </ion-title>
    </ion-toolbar>
  </ion-header>
}

<ion-content class="content-theme-one" style="overflow: auto;">


  @if ((mobile && !settings.navigationSetting) && settings.configuration.uIoptions) {
    <app-undocked-navigation-bar style="position: relative; z-index: 10;"></app-undocked-navigation-bar>
  }

  <!--
  <table class="tables">
    <thead>
      <tr>
        <th>Nutritions</th>
      </tr>
    </thead>
    <tbody>
      @for (nutrition of nutritions; track nutrition) {
        @if(nutrition.isActive) {
          <tr>
            <td>{{ nutrition.name.translations[translationService.getLanguage()] }}</td>
          </tr>
        }
      }
    </tbody>
  </table>

  <table class="tables">
    <thead>
      <tr>
        <th>Allergens</th>
      </tr>
    </thead>
    <tbody>
      @for (allergen of allergens; track allergen) {
        @if(allergen.isActive) {
          <tr>
            <td>{{ allergen.name.translations[translationService.getLanguage()] }}</td>
          </tr>
        }
      }
    </tbody>
  </table>
  -->

  @if (this.flavors) {

    <div class="topInformation">
      <div class="titleText">

      </div>
      <div class="descriptionText">

      </div>
      <div class="optionsAndSearch">
        <div class="storesDropDownContainer" (click)="$event.stopPropagation()">
          <div class="dropdown" (click)="isOpen = !isOpen">
            
              <span class="storeSelected">
                @if(selectedStore) {
                  {{ selectedStore.displayName }}
                } @else {
                  {{ 'all' }}
                }
              </span>
            
            
            <span class="arrow" [class.open]="isOpen">▾</span>
          </div>

          <ul class="dropdown-menu" [class.open]="isOpen" >
            @if(stores.length > 0) {
              <li (click)="selectStore()">
                {{ 'all' }}
              </li>
              
              @for (store of stores; track store) {
                <li (click)="selectStore(store)">
                  {{ store.displayName }}
                </li>
              }
            }
            
            
          </ul>   
        </div>
        <div class="searchContainer">

        </div>
      </div>
    </div>

    <div class="tableWrapper">
        <table class="Table">
          <thead>
            <tr>
              <th #headerCell>
                <div #headerText>
                </div>
              </th>
              @for (flavor of this.flavors.flavors; track flavor) {
                <th #headerCell class="angled-th">
                  <div #headerText class="angled-text">
                    {{ flavor.name.translations[translationService.getLanguage()] }}
                  </div>
                </th>
              }
            </tr>
          </thead>
          <tbody class="bodySeperator">
            
            @for (itemId of this.flavors.itemIds; track itemId; let y = $index) {
              <tr class="seperatorRow" [ngClass]="{'sperator': y != 0}">
                <td (click)="openItemContentDetails('flavor', itemId)" class="tableData itemNameCell">{{ getItemFlavorName(itemId) }}</td>
                @for (flavor of this.flavors.flavors; track flavor; let i = $index) {
                  <td class="tableData" [ngClass]="{ 'styledCell': i % 2 === 0 }">
                    @if(getItemFlavorValue(itemId, flavor)) {
                      <ion-icon style="color: black;" size="small" slot="start" [ios]="'checkmark'" [md]="'checkmark'"></ion-icon>
                    }
                  </td>
                }
              </tr>
            }


                    

          </tbody>
        </table>
    </div>
  }


</ion-content>